import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import { createTheme } from '@mui/material';
import { BrowserRouter as Router, Route, useLocation, Switch, Redirect } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

import { Env } from '@functions/index';

import Navbar from '@layout/Navbar/Navbar';

import Home from '@pages/Home';
import AboutUs from '@pages/AboutUs';
import ContactSimple from '@pages/ContactSimple';
import Services from '@pages/Services';

import AdminVisits from '@pages/Admin/Visits';
import AdminUnavailability from '@pages/Admin/Unavailability';

import settings from '@assets/settings';

import './style.scss';

const baseTheme = {
  palette: {
    primary: {
      main: 'rgba(0, 171, 114, 1)',
      light: 'rgba(0, 216, 143, 1)',
    },
    secondary: grey,
  },
  typography: {
    fontFamily: 'Poppins',
    h1: {
      fontSize: 46,
      textTransform: 'uppercase',
      fontWeight: '500',
      textAlign: 'center',
    },
    h2: {
      fontSize: 40,
      textTransform: 'uppercase',
      fontWeight: '500',
      textAlign: 'center',
    },
    h3: {
      fontSize: 30,
      fontWeight: 300,
    },
    h5: {
      fontSize: 20,
      fontWeight: 300,
    },
    h6: {
      fontSize: 16,
      fontWeight: 300,
    },
    subtitle1: {
      fontSize: 22,
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: 16,
      fontWeight: 400,
    },
    body1: {
      fontWeight: 300,
      fontSize: 15,
      lineHeight: 1.4,
    },
    body2: {
      fontWeight: 300,
      fontSize: 13,
    },
  },
};

const theme = createTheme(baseTheme);

const useScrollRestoration = () => {
  const location = useLocation();

  useEffect(() => {
    window.scroll(0, 0);
  }, [location.pathname]);
};

const Routes = () => {
  const location = useLocation();
  const noLayout = location.pathname.includes('/admin');

  useScrollRestoration();

  return (
    <>
      {!noLayout && <Navbar />}
      <Switch>
        <Route exact path={`/`} component={Home} />
        <Route exact path={`/about`} component={AboutUs} />
        <Route exact path={`/services`} component={Services} />
        <Route exact path={`/contact`} component={ContactSimple} />

        <Route exact path={`/admin`} component={AdminUnavailability} />
        <Route exact path={`/admin/visits`} component={AdminVisits} />

        <Redirect to="/" />
      </Switch>
      {/** !noLayout && <Footer /> **/}
    </>
  );
};

export const App = () => (
  <ThemeProvider theme={theme}>
    <Router>
      <Routes />
    </Router>
  </ThemeProvider>
);
